import { Boxes, CircleCheck, Link2, PackageOpen } from 'lucide-react';
import { focusRing, num } from './shared';

// How designs move through the catalogue: one box per stage, left to right,
// each counting the designs that got that far. What drops out on the way
// (no link, failed, link gone, ...) is in the stats above and in Full catalogue.

function pct(part, whole) {
  if (!whole) return '0%';
  const p = (part / whole) * 100;
  return p > 0 && p < 1 ? '<1%' : `${Math.round(p)}%`;
}

// Points right, or down where the boxes stack. `live` (a run is reading
// pages) sets it flowing.
function Arrow({ live }) {
  const tone = live ? 'stroke-sky-400' : 'stroke-gray-300';
  return (
    <div className="flex items-center justify-center shrink-0 h-10 md:h-auto md:w-10" aria-hidden>
      <svg viewBox="0 0 40 12" className="w-10 h-3 rotate-90 md:rotate-0 overflow-visible">
        <line x1="1" y1="6" x2="35" y2="6" strokeWidth="2" strokeLinecap="round"
          strokeDasharray={live ? '4 4' : undefined} className={`${tone} ${live ? 'catalogue-dash' : ''}`} />
        <path d="M31 1.5 37 6 31 10.5" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          className={tone} />
      </svg>
    </div>
  );
}

function Box({ icon: Icon, title, value, sub, accent, onClick }) {
  const body = (
    <>
      <span className={`block h-0.5 w-6 rounded-full ${accent}`} aria-hidden />
      <span className="mt-3 flex items-center gap-1.5 text-[12.5px] font-medium text-gray-600">
        <Icon size={14} className="shrink-0 text-gray-400" aria-hidden />{title}
      </span>
      <span className="mt-2 block text-[24px] leading-none font-semibold tracking-tight text-gray-900 tabular-nums">
        {num(value)}
      </span>
      <span className="mt-1.5 block text-[12px] text-gray-400 tabular-nums">{sub}</span>
    </>
  );
  const box = 'flex-1 min-w-0 rounded-lg border border-gray-200 bg-white px-4 py-3.5 text-left';
  return onClick
    ? (
      <button type="button" onClick={onClick}
        className={`${box} hover:border-gray-300 hover:bg-gray-50 transition-colors ${focusRing}`}>{body}</button>
    )
    : <div className={box}>{body}</div>;
}

export default function FlowChart({ designs, imported, counts, running, onPick }) {
  const c = counts || {};
  const withLink = ['pending', 'done', 'failed', 'dead_link', 'unsupported'].reduce((s, k) => s + (c[k] || 0), 0);
  const done = c.done || 0;
  const open = (status) => (onPick ? () => onPick(status) : undefined);

  return (
    <div className="flex flex-col md:flex-row md:items-stretch">
      <Box icon={Boxes} title="Designs in ZOCS" value={designs} sub="every design" accent="bg-sky-400" />
      <Arrow />
      <Box icon={PackageOpen} title="In catalogue queue" value={imported} sub={`${pct(imported, designs)} of ZOCS`}
        accent="bg-sky-400" onClick={open(null)} />
      <Arrow />
      <Box icon={Link2} title="Have a product link" value={withLink} sub={`${pct(withLink, imported)} of the queue`}
        accent="bg-sky-400" />
      <Arrow live={running} />
      <Box icon={CircleCheck} title="Scraped" value={done} sub={`${pct(done, withLink)} of links`}
        accent="bg-zoddle-green" onClick={open('done')} />
    </div>
  );
}
